export var LogzGraphTestSubjects;
(function (LogzGraphTestSubjects) {
    LogzGraphTestSubjects["HighchartsReactSubject"] = "logz-graph";
    LogzGraphTestSubjects["TooltipComponent"] = "logz-graph-tooltip";
    LogzGraphTestSubjects["SeriesContextMenuSubject"] = "logz-graph-series-context-menu";
    LogzGraphTestSubjects["EventActionMenuSubject"] = "logz-graph-event-action-menu";
})(LogzGraphTestSubjects || (LogzGraphTestSubjects = {}));
//# sourceMappingURL=logz-graph.enum.js.map